import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://admin.local.dev:8080'}/api`;

class WaitlistService {
  async list() {
    const response = await axios.get(`${API_URL}/platform/waitlist`);
    return response.data.data || [];
  }
}

export default new WaitlistService();
